import InstagramIcon from "../icons/instagram.png";
import LinkedinIcon from "../icons/linkedin.png";
import WebsiteIcon from "../icons/website.png";
import FacebookIcon from "../icons/facebook.png";
import TwitterIcon from "../icons/twitter.png";

export const NEW_CASE_STEPS = [
  "Add client & Assigment information",
  "Case information",
  "Add subject or update information",
];

export const CASE_TYPES = [
  " ",
  "Surplus Funds",
  "Locate for Service of Process",
  "PI Investigation",
  "Locate Witness",
  "Background",
];

export const GENDERS = [" ", "Male", "Female"];

export const MARITAL_STATUS = [
  " ",
  "Married",
  "Single",
  "Divorced",
  "Widowed",
  "Common Law",
];

export const SUBJECT_LOGOS = [
  FacebookIcon,
  TwitterIcon,
  InstagramIcon,
  LinkedinIcon,
  WebsiteIcon,
];


export const PX_TO_PT = 0.75
